import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useGraphDataContext } from "providers/graph-panel";
import { IconButton } from "ui/components/elements/icons/icon-button";
import { OpenInWindowIcon } from "ui/components/elements/icons/open-in-window";
import { DockIcon } from "ui/components/elements/icons/dock";
/**
 * Pops the whole dashboard (the boxes with the graph panel) out into a
 * separate window, or docks it back. The graph panel has its own button for
 * popping out the charts alone.
 */
export var DashboardPopOutButton = function () {
    var t = useTranslation().t;
    var _a = useGraphDataContext(), dashboardWindow = _a.dashboardWindow, popOut = _a.popOut, dock = _a.dock;
    var label = t(dashboardWindow ? "dashboard.dock" : "dashboard.pop_out");
    return (_jsx(IconButton, { appearance: "text", color: "inverted", onClick: dashboardWindow ? dock : function () { return popOut("dashboard"); }, tooltip: label, rootAttributes: { "aria-label": label }, children: dashboardWindow ? (_jsx(DockIcon, { size: 16 })) : (_jsx(OpenInWindowIcon, { size: 16 })) }));
};
